import { AppStorageKeys } from "./Constants";

class LocalStorage {
  static get = (key) => {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      switch (key) {
        case AppStorageKeys.currentUser:
          return {};
        case AppStorageKeys.tipMessage:
          return false;
        case AppStorageKeys.tipTech:
          return false;
        default:
          return {};
      }
    }
  };

  static set = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.log("Error setting local storage:", key);
    }
  };

  static remove = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.log("Error removing local storage:", key);
    }
  };
}

export default LocalStorage;
